import { IconButton, Icon } from "@chakra-ui/react";
import { VscQuestion } from "react-icons/vsc";

const TutorialButton = ({ onClick }) => {
    return (
        <IconButton
            aria-label="Show Tutorial"
            onClick={onClick}
            bg="white"
            color="black"
            border="2px solid #000"
            _hover={{ bg: "gray.100" }}
            h="40px"
            w="40px"
            minW="40px"
            borderRadius="0"
            fontSize="md"
        >
            <Icon as={VscQuestion} />
        </IconButton>
    );
};

export default TutorialButton;
